import React from "react";
import Loginright from "./Loginright";
import Loginleft from "./Loginleft";

const Signin = () => {
  return (
   
      <div className="row g-0 min-100vh flex-column flex-lg-row justify-content-center">
       
        <Loginright />
      </div>

  );
};

export default Signin;
